import { Injectable, NgZone } from '@angular/core';
import { timer, Subscription } from 'rxjs';
import { UtilsService } from './utils.service';

declare var $crisp;

@Injectable({
  providedIn: 'root',
})
export class ChatService {

  shouldTrigger = false;
  loaded = false;
  loading = false;

  subscription: Subscription;

  constructor(
    private utils: UtilsService,
    private ngZone: NgZone
  ) {
    if (utils.isBrowser) {
      $crisp.push(['on', 'session:loaded', () => {
        this.sessionLoaded();
        this.hideLoadingIndicator();
      }]);

      $crisp.push(['on', 'chat:closed', this.hideChatButton]);
    }
  }

  sessionLoaded() {
    this.loaded = true;
    if (this.shouldTrigger) {
      this.runTrigger();
    }
  }

  openChat() {
    if (this.utils.isBrowser) {
      $crisp.push(['do', 'chat:show']);
      $crisp.push(['do', 'chat:open']);
      if (!document.getElementById('crisp-script')) {
        this.loading = true;
        const script = document.createElement('script');
        script.src = '/external/crisp.js';
        script.async = true;
        script.id = 'crisp-script';
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  }

  hideChatButton() {
    if (this.utils.isBrowser) {
      this.ngZone.run(_ => {
        $crisp.push(['do', 'chat:hide']);
      });
    }
  }

  hideLoadingIndicator() {
    if (this.utils.isBrowser) {
      this.ngZone.run(_ => {
        this.loading = false;
      });
    }
  }

  runTrigger() {
    this.shouldTrigger = true;
    if (this.loaded) {
      const countdown = timer(61000);
      this.subscription = countdown.subscribe(x => {
        if (this.shouldTrigger) {
          this.openChat();
        }
      });
    }
  }

  setUserEmail(email: string) {
    if (this.utils.isBrowser) {
      $crisp.push(['set', 'user:email', email]);
      $crisp.push(['do', 'chat:hide']);
    }
  }

  cancelTrigger() {
    this.shouldTrigger = false;
    this.subscription?.unsubscribe();
  }

}
